import React, { useRef, useState, useEffect } from "react";

const TriStateCheckbox = ({ 
  value, 
  onStateChange, 
  disabled = false 
}: { 
  value: number, 
  onStateChange: any, 
  disabled?: boolean 
}) => {
  const [state, setState] = useState<number>(value); // 0: unchecked, 1: checked, 2: indeterminate
  const checkboxRef = useRef<HTMLInputElement>(null);

  // Keep internal state in sync when `value` prop changes from parent
  useEffect(() => {
    setState(value);
  }, [value]);

  // Update checkbox visual state when internal `state` changes
  useEffect(() => {
    if (checkboxRef.current) {
      if (state === 0) {
        checkboxRef.current.checked = false;
        checkboxRef.current.indeterminate = false;
      } else if (state === 1) {
        checkboxRef.current.checked = true;
        checkboxRef.current.indeterminate = false;
      } else if (state === 2) {
        checkboxRef.current.checked = false;
        checkboxRef.current.indeterminate = true;
      }
    }
  }, [state]);

  const handleClick = () => {
    if (disabled) return;

    setState((prevState) => {
      const nextState = (prevState + 1) % 3; // Cycle through states
      if (onStateChange) {
        onStateChange(nextState);
      }
      return nextState;
    });
  };

  return (
    <div>
      <input
        type="checkbox"
        ref={checkboxRef}
        onClick={handleClick}
        className="form-checkbox"
        disabled={disabled}
      />
    </div>
  );
};

export default TriStateCheckbox;
